export default "__VITE_ASSET__qr47Y8m0__"